import { createRoute } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { TelemetryPage } from '../../Views'

export const telemetryRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/telemetry',
  component: TelemetryPage,
})
